// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UserManagement.css */
.user-management-container {
    font-family: 'Roboto', 'Segoe UI', Arial, sans-serif;
  }
  
  /* Адаптивні стилі для мобільних пристроїв */
  @media (max-width: 768px) {
    .user-management-table {
      font-size: 0.875rem;
    }
    
    .user-management-table th,
    .user-management-table td {
      padding: 8px 4px;
    }
    
    .user-management-actions {
      flex-direction: column;
      gap: 4px;
    }
  }
  
  /* Стилі для темної теми */
  @media (prefers-color-scheme: dark) {
    .user-management-container {
      background-color: #1a1a1a;
      color: #ffffff;
    }
    
    .user-management-paper {
      background-color: #2d2d2d;
      color: #ffffff;
    }
  }
  
  /* Анімації */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .user-management-row {
    animation: fadeIn 0.3s ease-out;
  }
  
  /* Кастомні скроллбари */
  .user-management-table-container::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }
  
  .user-management-table-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  .user-management-table-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  .user-management-table-container::-webkit-scrollbar-thumb:hover {
    background: #555;
  }`, "",{"version":3,"sources":["webpack://./src/components/rest/UserManagement.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;IACI,oDAAoD;EACtD;;EAEA,4CAA4C;EAC5C;IACE;MACE,mBAAmB;IACrB;;IAEA;;MAEE,gBAAgB;IAClB;;IAEA;MACE,sBAAsB;MACtB,QAAQ;IACV;EACF;;EAEA,0BAA0B;EAC1B;IACE;MACE,yBAAyB;MACzB,cAAc;IAChB;;IAEA;MACE,yBAAyB;MACzB,cAAc;IAChB;EACF;;EAEA,aAAa;EACb;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,+BAA+B;EACjC;;EAEA,wBAAwB;EACxB;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB","sourcesContent":["/* UserManagement.css */\r\n.user-management-container {\r\n    font-family: 'Roboto', 'Segoe UI', Arial, sans-serif;\r\n  }\r\n  \r\n  /* Адаптивні стилі для мобільних пристроїв */\r\n  @media (max-width: 768px) {\r\n    .user-management-table {\r\n      font-size: 0.875rem;\r\n    }\r\n    \r\n    .user-management-table th,\r\n    .user-management-table td {\r\n      padding: 8px 4px;\r\n    }\r\n    \r\n    .user-management-actions {\r\n      flex-direction: column;\r\n      gap: 4px;\r\n    }\r\n  }\r\n  \r\n  /* Стилі для темної теми */\r\n  @media (prefers-color-scheme: dark) {\r\n    .user-management-container {\r\n      background-color: #1a1a1a;\r\n      color: #ffffff;\r\n    }\r\n    \r\n    .user-management-paper {\r\n      background-color: #2d2d2d;\r\n      color: #ffffff;\r\n    }\r\n  }\r\n  \r\n  /* Анімації */\r\n  @keyframes fadeIn {\r\n    from {\r\n      opacity: 0;\r\n      transform: translateY(10px);\r\n    }\r\n    to {\r\n      opacity: 1;\r\n      transform: translateY(0);\r\n    }\r\n  }\r\n  \r\n  .user-management-row {\r\n    animation: fadeIn 0.3s ease-out;\r\n  }\r\n  \r\n  /* Кастомні скроллбари */\r\n  .user-management-table-container::-webkit-scrollbar {\r\n    height: 8px;\r\n    width: 8px;\r\n  }\r\n  \r\n  .user-management-table-container::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .user-management-table-container::-webkit-scrollbar-thumb {\r\n    background: #888;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .user-management-table-container::-webkit-scrollbar-thumb:hover {\r\n    background: #555;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
